import { useFetchData } from "../../../hooks/useFetch";
import { BaseResponse } from "../../../models/response/base-response";
import { ApiConfig, API_ORDER_ROUTER } from "../../../services/api-config";

const toVietnameseDate = (isoDate: string): string => {
  if (!isoDate) return "";
  const [year, month, day] = isoDate.split("-");
  return `${day}-${month}-${year}`; // đổi sang DD/MM/YYYY
};
export enum ORDER_STATUS {
  WAITING_ACCEPT = 1, // ĐỢI XÁC NHẬN
  WAITING_PICK_UP = 2, // ĐANG LẤY HÀNG
  WAITING_LAUNDRY = 3, // Chờ giặt
  IN_LAUNDRING = 4, // Đang giặt
  COMPLETE = 5,//Hoàn thành
  READY_DELIVERY = 6, // Sẵn sàng giao
  IN_DELIVERY = 7,//Đang giao
  CANCELED = 8,//Huỷ
  COUNTING = 9, // Kiểm đếm khi nhận (với khách)
  // Extended Workflow (Phase 2)
  INSPECTING = 10,  // Kiểm tra / Phân loại
  WASHING = 11,     // Đang giặt (chi tiết)
  DRYING = 12,      // Đang sấy
  IRONING = 13,     // Đang ủi
  FOLDING = 14,     // Đang gấp
  WAITING_DRY = 15, // Chờ sấy
  WAITING_IRON = 16,// Chờ ủi
  WAITING_FOLD = 17,// Chờ gấp
  DELIVERY_COUNTING = 18, // Kiểm đếm khi giao (với khách)
  COUNTING_DONE = 19, // Đã kiểm đếm xong, chờ "Giao tài xế"
  WAITING_DRIVER = 20, // Chờ giao tài xế
  TRANSFERRING = 21, // Đang điều chuyển giữa các chi nhánh
}
export enum ORDER_STATUS_NAME {
  WAITING_ACCEPT = "ĐỢI XÁC NHẬN",
  WAITING_PICK_UP = "ĐỢI LẤY HÀNG",
  IN_DELIVERY = "ĐANG GIAO",
  COMPLETE = "HOÀN THÀNH",
  CANCELED = "HỦY",
  READY_DELIVERY = "SẴN SÀNG GIAO",
  IN_LAUNDRING = "ĐANG GIẶT",
  WAITING_LAUNDRY = "CHỜ GIẶT",
  COUNTING = "KIỂM ĐẾM",
  DELIVERY_COUNTING = "KIỂM ĐẾM GIAO",
  COUNTING_DONE = "ĐÃ KIỂM ĐẾM XONG",
  WAITING_DRIVER = "CHỜ GIAO TÀI XẾ",
  TRANSFERRING = "ĐANG ĐIỀU CHUYỂN",
  // Extended Workflow (Phase 2)
  INSPECTING = "KIỂM TRA",
  WASHING = "ĐANG SẢN XUẤT",
  DRYING = "ĐANG SẤY",
  IRONING = "ĐANG ỦI",
  FOLDING = "ĐANG GẤP",
  WAITING_DRY = "CHỜ SẤY",
  WAITING_IRON = "CHỜ ỦI",
  WAITING_FOLD = "CHỜ GẤP",
}
export const ORDER_STATUS_LABELS: Record<number, string> = {
  [ORDER_STATUS.WAITING_ACCEPT]: ORDER_STATUS_NAME.WAITING_ACCEPT,
  [ORDER_STATUS.WAITING_PICK_UP]: ORDER_STATUS_NAME.WAITING_PICK_UP,
  [ORDER_STATUS.WAITING_LAUNDRY]: ORDER_STATUS_NAME.WAITING_LAUNDRY,
  [ORDER_STATUS.IN_LAUNDRING]: ORDER_STATUS_NAME.IN_LAUNDRING,
  [ORDER_STATUS.READY_DELIVERY]: ORDER_STATUS_NAME.READY_DELIVERY,
  [ORDER_STATUS.IN_DELIVERY]: ORDER_STATUS_NAME.IN_DELIVERY,
  [ORDER_STATUS.COMPLETE]: ORDER_STATUS_NAME.COMPLETE,
  [ORDER_STATUS.CANCELED]: ORDER_STATUS_NAME.CANCELED,
  [ORDER_STATUS.COUNTING]: ORDER_STATUS_NAME.COUNTING,
  [ORDER_STATUS.DELIVERY_COUNTING]: ORDER_STATUS_NAME.DELIVERY_COUNTING,
  [ORDER_STATUS.COUNTING_DONE]: ORDER_STATUS_NAME.COUNTING_DONE,
  [ORDER_STATUS.WAITING_DRIVER]: ORDER_STATUS_NAME.WAITING_DRIVER,
  [ORDER_STATUS.TRANSFERRING]: ORDER_STATUS_NAME.TRANSFERRING,
  // Extended Workflow (Phase 2)
  [ORDER_STATUS.INSPECTING]: ORDER_STATUS_NAME.INSPECTING,
  [ORDER_STATUS.WASHING]: ORDER_STATUS_NAME.WASHING,
  [ORDER_STATUS.WAITING_DRY]: ORDER_STATUS_NAME.WAITING_DRY,
  [ORDER_STATUS.DRYING]: ORDER_STATUS_NAME.DRYING,
  [ORDER_STATUS.WAITING_IRON]: ORDER_STATUS_NAME.WAITING_IRON,
  [ORDER_STATUS.IRONING]: ORDER_STATUS_NAME.IRONING,
  [ORDER_STATUS.WAITING_FOLD]: ORDER_STATUS_NAME.WAITING_FOLD,
  [ORDER_STATUS.FOLDING]: ORDER_STATUS_NAME.FOLDING,
};

// Màu badge trạng thái — DÙNG CHUNG cho list, chi tiết, thanh quy trình.
export const STATUS_BADGE_STYLES: Record<number, string> = {
  [ORDER_STATUS.WAITING_ACCEPT]: "bg-amber-100 text-amber-700",
  [ORDER_STATUS.WAITING_PICK_UP]: "bg-yellow-100 text-yellow-700",
  [ORDER_STATUS.WAITING_LAUNDRY]: "bg-blue-100 text-blue-700",
  [ORDER_STATUS.IN_LAUNDRING]: "bg-indigo-100 text-indigo-700",
  [ORDER_STATUS.COMPLETE]: "bg-green-100 text-green-700",
  [ORDER_STATUS.READY_DELIVERY]: "bg-teal-100 text-teal-700",
  [ORDER_STATUS.IN_DELIVERY]: "bg-purple-100 text-purple-700",
  [ORDER_STATUS.CANCELED]: "bg-red-100 text-red-700",
  [ORDER_STATUS.COUNTING]: "bg-lime-100 text-lime-700",
  [ORDER_STATUS.COUNTING_DONE]: "bg-lime-100 text-lime-700",
  [ORDER_STATUS.WAITING_DRIVER]: "bg-amber-100 text-amber-700",
  [ORDER_STATUS.TRANSFERRING]: "bg-orange-100 text-orange-700",
  [ORDER_STATUS.DELIVERY_COUNTING]: "bg-emerald-100 text-emerald-700",
  // Extended Workflow (Phase 2)
  [ORDER_STATUS.INSPECTING]: "bg-cyan-100 text-cyan-700",
  [ORDER_STATUS.WASHING]: "bg-indigo-100 text-indigo-700",
  [ORDER_STATUS.DRYING]: "bg-orange-100 text-orange-700",
  [ORDER_STATUS.IRONING]: "bg-rose-100 text-rose-700",
  [ORDER_STATUS.FOLDING]: "bg-fuchsia-100 text-fuchsia-700",
  [ORDER_STATUS.WAITING_DRY]: "bg-sky-100 text-sky-700",
  [ORDER_STATUS.WAITING_IRON]: "bg-pink-100 text-pink-700",
  [ORDER_STATUS.WAITING_FOLD]: "bg-violet-100 text-violet-700",
};
/**
 * Nhóm lý do GIẶT LẠI (khớp `REWASH_REASON` ở BE) — chỉ để thống kê ở báo cáo giặt lại.
 * Không thay ô mô tả chi tiết: NV vẫn nhập text như cũ.
 */
export const REWASH_REASON_OPTIONS: { value: string; label: string }[] = [
  { value: "DIRTY", label: "Còn bẩn / vết chưa sạch" },
  { value: "ODOR", label: "Còn mùi" },
  { value: "WRINKLED", label: "Nhăn, ủi chưa đạt" },
  { value: "DAMAGED", label: "Bạc màu / hư hỏng do giặt" },
  { value: "OTHER", label: "Khác" },
];
export const REWASH_REASON_LABEL: Record<string, string> = Object.fromEntries(
  REWASH_REASON_OPTIONS.map((r) => [r.value, r.label]),
);

export enum IS_DEBIT {
  NO_DEBIT = 0, // không nợ
  DEBIT = 1, // nợ
}
export enum PAYMENT_METHOD {
  CASH = 1, // Tiền mặt
  QR_CODE = 2, // Chuyển khoản
  CONG_NO = 3, // Công nợ
}
export enum PAYMENT_METHOD_NAME {
  CASH = "Tiền mặt",
  QR_CODE = "Chuyển khoản",
  CONG_NO = "Công nợ",
}
export const PAYMENT_METHOD_LABELS: Record<number, string> = {
  [PAYMENT_METHOD.CASH]: PAYMENT_METHOD_NAME.CASH,
  [PAYMENT_METHOD.QR_CODE]: PAYMENT_METHOD_NAME.QR_CODE,
};
export interface OrderItem {
  id?: number;
  customer_id: number;
  address: string;
  status?: number;
  code?: string;
  employee_id?: number;
  employee_update_id?: number;
  note?: string;
  total_amount?: number | string;
  reason_cancel?: string;
  branch_id?: number;
  current_branch_id?: number; // Nơi đồ đang nằm (điều chuyển). Khác branch_id nếu đã điều chuyển.
  created_at?: string;
  updated_at?: string;
  // quan hệ mở rộng
  customer?: {
    id?: number;
    name?: string;
    phone?: string;
    address?: string;
    status?: number;
  };
  branch?: {
    id?: number;
    name?: string;
    address?: string;
    company_name?: string;
    status?: number;
  };
  // Chi nhánh đang GIỮ đồ (điều chuyển / giữ hộ). Khác `branch` nếu đồ đang ở nơi khác chủ đơn.
  current_branch?: {
    id?: number;
    name?: string;
    address?: string;
    status?: number;
  } | null;
  driverPickup?: {
    id?: number;
    name?: string;
    phone?: string;
    status?: number;
  };
  driverDelivery?: {
    id?: number;
    name?: string;
    phone?: string;
    status?: number;
  };
  employee?: {
    id?: number;
    name?: string;
    phone?: string;
    status?: number;
  };
  /** Người TẠO đơn (employee_create_id) — khác `employee` (người XỬ LÝ giặt, employee_id). */
  employeeCreate?: {
    id?: number;
    name?: string;
    phone?: string;
    status?: number;
  } | null;
  /** Nhân viên Sale phụ trách khách hàng lúc tạo đơn */
  employeeSale?: {
    id?: number;
    name?: string;
    phone?: string;
    status?: number;
  } | null;
  sale_id?: number | null;
  is_debit?: number;
  payment_method?: number;
  /** Thanh toán chuyển khoản QR: 0 = đang chờ, 1 = đã nhận tiền, 2 = lỗi, 3 = đã huỷ */
  payment_status?: number | null;
  amount_discount?:number;
  is_pickup_laundry ?: number,
  pickup_driver_id ?: number,
  delivery_driver_id ?: number
  scheduled_delivery_at?: string;
  // Weight tracking (cân 2 lần)
  pickup_weight?: number;  // Số ký khi nhận hàng (cân lần 1)
  final_weight?: number;   // Số ký sau giặt (cân lần 2) — dùng tính tiền
  // Employee assignments
  employees?: Array<{
    id: number;
    employee_id: number;
    role_type: number;
    assigned_weight?: number;
    wage_rate?: number;
    calculated_wage?: number;
    status: number;
    reject_reason?: string;
    employee?: {
      id: number;
      name: string;
      phone?: string;
    };
  }>;
  // Images - ảnh xác nhận theo trạng thái. `/detail` trả CHUỖI JSON; mỗi status là 1 URL hoặc mảng URL
  // (bước kiểm đếm cho nhiều ảnh) → luôn chuẩn hoá trước khi render.
  caption_images?: string | Record<string, string | string[]>;
  // Chứng từ thanh toán nợ
  image_document?: string;
  // Kiểm đếm với khách (1 = đơn cần kiểm đếm) — đổi nhánh chuyển trạng thái
  requires_counting?: number;
  // Xe tải ĐI THẲNG theo chiều (null = xe máy) — xem user/docs/xe-tai-doi-hinh-ky-thuat.md
  pickup_vehicle_id?: number | null;
  delivery_vehicle_id?: number | null;
  // Loại đơn: 1=Bình thường, 2=Giặt lại
  order_type?: number;
  // CSV id nhân sự chịu trách nhiệm (đơn giặt lại)
  responsible_user_ids?: string;
  // Đơn gốc liên quan (đơn giặt lại đứng riêng)
  related_order_id?: number | null;
  // Enrich từ getDetailOrder (chỉ đơn giặt lại)
  related_order_code?: string | null;
  responsible_names?: string | null;
  // Cấu hình giảm giá đơn giặt lại: 0=miễn phí, 1=theo %, 2=theo số tiền, 3=thu đủ
  rewash_discount_type?: number | null;
  rewash_discount_value?: number | null;
  // Tách đồ giặt lại lúc TRẢ HÀNG (app): tiền đã trừ khỏi ĐƠN CHÍNH (khách chỉ trả phần đồ sạch)
  rewash_deduct_amount?: number | string | null;
  // Giá đã CHỐT của ĐƠN GIẶT LẠI khi tách — cân lại sau khi giặt không làm đổi số phải thu
  rewash_locked_amount?: number | string | null;
  // Phiếu giặt lại đang chạy của đơn này (mỗi đơn gốc chỉ 1 phiếu chưa hoàn tất/hủy)
  open_rewash_order?: { id: number; code: string; status: number } | null;
  // Extended Workflow
  workflow_type?: number;           // default: 1
  current_step_code?: string | null;
  parent_order_id?: number | null;
  sub_order_index?: number | null;
  has_sub_orders?: number;
  classification_category?: string | null;
  item_count?: number | null;
  prefill_count_from_last?: number; // 1 = tự điền phân loại từ đơn gần nhất của khách
  active_bag_count?: number; // Số túi đang gắn (đã đóng túi nhưng có thể chưa bấm "Sẵn sàng giao")
  sub_orders?: Array<{
    id: number;
    code: string;
    status: number;
    sub_order_index: number;
    classification_category: string;
    item_count: number;
    pickup_weight: number | null;
    final_weight: number | null;
    total_amount: number | null;
    amount_discount: number | null;
    employees?: Array<any>;
  }>;
  workflow_steps?: Array<{
    id: number;
    code: string;
    name: string;
    status_code: number;
    sort_order: number;
    require_qr_scan: boolean;
    require_photo: boolean;
    require_weight: boolean;
    equipment_type: number | null;
    is_active: boolean;
  }>;
}

export interface OrderFilters {
  page?: number;
  limit?: number;
  branch_id?: number;
  from_date?: string;
  to_date?: string;
  /** 1 trạng thái hoặc nhiều trạng thái (lọc nhiều) — gửi lên BE dạng "1,2,3". */
  statuses?: number | number[];
  key_search?: string;
  customer_id?: number;
  pickup_driver_id?: number;
  delivery_driver_id?: number;
  employee_id?: number;
  assigned_employee_id?: number;
  order_type?: number; // 1=Bình thường, 2=Giặt lại
  requires_counting?: number; // 0=đơn thường, 1=đơn kiểm đếm (bỏ trống = tất cả)
  // 'consigned' = đơn (kể cả đơn con) chi nhánh mình đang giữ hộ / sắp nhận điều chuyển
  scope?: string;
}

export type OrderApiData =
  | OrderItem[]
  | {
      list?: OrderItem[];
      items?: OrderItem[];
      total_record?: number;
      total?: number;
      limit?: number;
      page?: number;
      current_page?: number;
    };

export type OrderApiResponse = BaseResponse<OrderApiData> | undefined;

export const OrderService = {
  /**
   * Danh sách đơn hàng
   */
  list: () => {
    const { request, baseResponse, loading, error } = useFetchData.Get<OrderApiData>({
      projectId: ApiConfig.PROJECT_ID.ORDER_SERVICE,
    });

    const toVietnameseDate = (isoDate?: string) => {
      if (!isoDate) return undefined;
      const [year, month, day] = isoDate.split("-");
      return `${day}-${month}-${year}`;
    };

    return {
      fetch: (params: OrderFilters = {}): Promise<OrderApiResponse> => {
        const queryParams = {
          page: params.page ?? 1,
          limit: params.limit ?? 20,
          // Mảng → chuỗi "1,2,3" (BE GetOrderLaundryDto tách theo dấu phẩy); tránh axios gửi `statuses[]=`.
          statuses: Array.isArray(params.statuses)
            ? (params.statuses.length ? params.statuses.join(",") : undefined)
            : params.statuses,
          key_search: params.key_search,        
          customer_id: params.customer_id, 
          branch_id: params.branch_id,
          pickup_driver_id: params.pickup_driver_id,
          delivery_driver_id: params.delivery_driver_id,
          employee_id: params.employee_id,
          assigned_employee_id: params.assigned_employee_id,
          order_type: params.order_type,
          requires_counting: params.requires_counting,
          scope: params.scope,
          from_date: toVietnameseDate(params.from_date),
          to_date: toVietnameseDate(params.to_date),
        };

        return request({
          endPoint: API_ORDER_ROUTER.API_LIST,
          data: queryParams,
        });
      },
      response: baseResponse,
      loading,
      error,
    };
  },

  /**
   * Tạo mới đơn hàng
   */
  create: () => {
    const { request, baseResponse, loading } = useFetchData.Post<OrderItem>({
      projectId: ApiConfig.PROJECT_ID.ORDER_SERVICE,
    });

    return {
      fetch: (payload: Partial<OrderItem>) =>
        request({
          endPoint: API_ORDER_ROUTER.API_CREATE,
          data: payload,
        }),
      response: baseResponse,
      loading,
    };
  },

  /**
   * Resync NV phụ trách khách cho các đơn đang mở — gọi sau khi đổi phân công khách ↔ NV.
   */
  resyncResponsibleCustomerStaff: () => {
    const { request, baseResponse, loading } = useFetchData.Post<{ updated: number }>({
      projectId: ApiConfig.PROJECT_ID.ORDER_SERVICE,
    });
    return {
      fetch: (customerIds: number[]) =>
        request({
          endPoint: API_ORDER_ROUTER.API_RESYNC_RESPONSIBLE_CUSTOMER_STAFF,
          data: { customer_ids: customerIds },
        }),
      response: baseResponse,
      loading,
    };
  },

  /**
   * Cập nhật đơn hàng
   */
  update: () => {
    const { request, baseResponse, loading } = useFetchData.Post<OrderItem>({
      projectId: ApiConfig.PROJECT_ID.ORDER_SERVICE,
    });

    return {
      fetch: (id: number, payload: Partial<OrderItem>) =>
        request({
          endPoint: API_ORDER_ROUTER.API_UPDATE(id),
          data: payload,
        }),
      response: baseResponse,
      loading,
    };
  },

  /**
   * Lấy chi tiết đơn hàng
   */
  detail: () => {
    const { request, baseResponse, loading, error } = useFetchData.Get<OrderItem>({
      projectId: ApiConfig.PROJECT_ID.ORDER_SERVICE,
    });

    return {
      fetch: (id: number) =>
        request({
          endPoint: API_ORDER_ROUTER.API_DETAIL(id),
        }),
      response: baseResponse,
      loading,
      error,
    };
  },
  /**
   * Generate payment QR code
   */
  generatePaymentQR: () => {
    const { request, baseResponse, loading } = useFetchData.Post<any>({
      projectId: ApiConfig.PROJECT_ID.ORDER_SERVICE,
    });
  
    return {
      fetch: (id: number, payment_method?: number) =>
        request({
          endPoint: API_ORDER_ROUTER.API_GENERATE_PAYMENT_QR_CODE(id),
          data: {
            id,
            ...(typeof payment_method === "number" ? { payment_method } : {}),
          },
        }),
      response: baseResponse,
      loading,
    };
  },
  /**
   * Get existing payment QR detail for an order
   */
  detailPaymentQR: () => {
    const { request, baseResponse, loading } = useFetchData.Get<any>({
      projectId: ApiConfig.PROJECT_ID.ORDER_SERVICE,
    });

    return {
      fetch: (id: number) =>
        request({
          endPoint: API_ORDER_ROUTER.API_DETAIL_PAYMENT_QR_CODE(id),
        }),
      response: baseResponse,
      loading,
    };
  },
  /**
   * Cancel payment QR transaction
   */
  cancelPaymentQR: () => {
    const { request, baseResponse, loading } = useFetchData.Post<any>({
      projectId: ApiConfig.PROJECT_ID.ORDER_SERVICE,
    });

    return {
      fetch: (id: number) =>
        request({
          endPoint: API_ORDER_ROUTER.API_CANCEL_PAYMENT_QR_CODE(id),
        }),
      response: baseResponse,
      loading,
    };
  },
  
  cancel : () => {
    const { request, baseResponse, loading } = useFetchData.Post<OrderItem>({
      projectId: ApiConfig.PROJECT_ID.ORDER_SERVICE,
    });
    return {
      fetch: (id: number, payload: Partial<OrderItem>) =>
        request({
          endPoint: API_ORDER_ROUTER.API_CANCEL(id),
          data: payload,
        }),
      response: baseResponse,
      loading,
    };
  },
  complete_order :() => {
    const { request, baseResponse, loading } = useFetchData.Post<OrderItem>({
      projectId: ApiConfig.PROJECT_ID.ORDER_SERVICE,
    });
    return {
      fetch: (id: number, payload: Partial<OrderItem>) =>
        request({
          endPoint: API_ORDER_ROUTER.API_CHANGE_STATUS(id),
          data: {
            ...payload,
            status: ORDER_STATUS.COMPLETE,
          },
        }),
      response: baseResponse,
      loading,
    };
  },

  /**
   * Chuyển trạng thái đơn hàng
   */
  changeStatus: () => {
    const { request, baseResponse, loading } = useFetchData.Post<OrderItem>({
      projectId: ApiConfig.PROJECT_ID.ORDER_SERVICE,
    });
    return {
      fetch: (
        id: number,
        status: number,
        classificationData?: Record<string, any>,
        extra?: { final_weight?: number; item_count?: number },
      ) =>
        request({
          endPoint: API_ORDER_ROUTER.API_CHANGE_STATUS(id),
          data: {
            status,
            ...(classificationData ? { classification_data: classificationData } : {}),
            ...(extra || {}),
          },
        }),
      response: baseResponse,
      loading,
    };
  },

  /**
   * Lưu phân loại đồ giặt ở bước Kiểm tra (INSPECTING) — CHỈ lưu classification_data, KHÔNG đổi trạng thái.
   * Việc chuyển sang "Đang sản xuất" do bước gắn sọt/máy giặt (assign) tự động thực hiện ở backend.
   */
  saveClassification: () => {
    const { request, baseResponse, loading } = useFetchData.Post<any>({
      projectId: ApiConfig.PROJECT_ID.ORDER_SERVICE,
    });
    return {
      fetch: (id: number, classificationData: Record<string, any>) =>
        request({
          endPoint: API_ORDER_ROUTER.API_CLASSIFICATION(id),
          data: { classification_data: classificationData },
        }),
      response: baseResponse,
      loading,
    };
  },

  /**
   * Đơn gần nhất (đã phân loại) của cùng khách hàng — dùng để prefill form Kiểm tra & Phân loại.
   */
  classificationFromServices: () => {
    const { request, baseResponse, loading } = useFetchData.Get<{
      items: { category_id: number; category: string; quantity: number }[];
      skipped: { item_name: string; quantity: number; reason: "no_linked_category" | "multiple_linked_categories" }[];
    }>({
      projectId: ApiConfig.PROJECT_ID.ORDER_SERVICE,
    });
    return {
      fetch: (orderId: number) =>
        request({
          endPoint: API_ORDER_ROUTER.API_CLASSIFICATION_FROM_SERVICES(orderId),
        }),
      response: baseResponse,
      loading,
    };
  },
  lastClassification: () => {
    const { request, baseResponse, loading } = useFetchData.Get<{
      items: { category: string; quantity: number }[];
      source_order_code: string | null;
    }>({
      projectId: ApiConfig.PROJECT_ID.ORDER_SERVICE,
    });
    return {
      fetch: (orderId: number) =>
        request({
          endPoint: API_ORDER_ROUTER.API_LAST_CLASSIFICATION(orderId),
        }),
      response: baseResponse,
      loading,
    };
  },

  /**
   * Lấy danh sách đơn con (sub-orders)
   */
  subOrders: () => {
    const { request, baseResponse, loading } = useFetchData.Get<OrderItem[]>({
      projectId: ApiConfig.PROJECT_ID.ORDER_SERVICE,
    });
    return {
      fetch: (orderId: number) =>
        request({
          endPoint: API_ORDER_ROUTER.API_SUB_ORDERS(orderId),
        }),
      response: baseResponse,
      loading,
    };
  },

  /**
   * Lấy lịch sử workflow của đơn hàng (Phase 2)
   */
  workflowHistory: () => {
    const { request, baseResponse, loading } = useFetchData.Get<any[]>({
      projectId: ApiConfig.PROJECT_ID.ORDER_SERVICE,
    });
    return {
      fetch: (orderId: number) =>
        request({
          endPoint: API_ORDER_ROUTER.API_WORKFLOW_HISTORY(orderId),
        }),
      response: baseResponse,
      loading,
    };
  },

  /**
   * Chia đơn hàng thành sub-orders (Phase 2)
   */
  reWash: () => {
    const { request, baseResponse, loading } = useFetchData.Post<any>({
      projectId: ApiConfig.PROJECT_ID.ORDER_SERVICE,
    });
    return {
      fetch: (params: { order_id: number; reason?: string; note?: string }) =>
        request({
          endPoint: API_ORDER_ROUTER.API_RE_WASH(params.order_id),
          data: { reason: params.reason, note: params.note },
        }),
      response: baseResponse,
      loading,
    };
  },

  splitOrder: () => {
    const { request, baseResponse, loading } = useFetchData.Post<any>({
      projectId: ApiConfig.PROJECT_ID.ORDER_SERVICE,
    });
    return {
      fetch: (orderId: number, groups: Array<{ name?: string; items: Array<{ category: string; quantity: number }>; weight?: number; equipment_ids?: number[]; equipment_codes?: string[] }>, note?: string) =>
        request({
          endPoint: API_ORDER_ROUTER.API_SPLIT_ORDER(orderId),
          data: { groups, note },
        }),
      response: baseResponse,
      loading,
    };
  },

  // ===== Điều chuyển chi nhánh =====
  createTransfer: () => {
    const { request, baseResponse, loading } = useFetchData.Post<any>({
      projectId: ApiConfig.PROJECT_ID.ORDER_SERVICE,
    });
    return {
      fetch: (orderId: number, payload: { to_branch_id: number; direction?: number; manifest?: Array<{ category: string; quantity: number }>; note?: string }) =>
        request({
          endPoint: API_ORDER_ROUTER.API_CREATE_TRANSFER(orderId),
          data: payload,
        }),
      response: baseResponse,
      loading,
    };
  },

  orderTransfers: () => {
    const { request, baseResponse, loading } = useFetchData.Get<any[]>({
      projectId: ApiConfig.PROJECT_ID.ORDER_SERVICE,
    });
    return {
      fetch: (orderId: number) =>
        request({ endPoint: API_ORDER_ROUTER.API_ORDER_TRANSFERS(orderId) }),
      response: baseResponse,
      loading,
    };
  },

  transferInTransit: () => {
    const { request, baseResponse, loading } = useFetchData.Post<any>({
      projectId: ApiConfig.PROJECT_ID.ORDER_SERVICE,
    });
    return {
      fetch: (transferId: number) =>
        request({ endPoint: API_ORDER_ROUTER.API_TRANSFER_IN_TRANSIT(transferId), data: {} }),
      response: baseResponse,
      loading,
    };
  },

  transferReceive: () => {
    const { request, baseResponse, loading } = useFetchData.Post<any>({
      projectId: ApiConfig.PROJECT_ID.ORDER_SERVICE,
    });
    return {
      fetch: (transferId: number) =>
        request({ endPoint: API_ORDER_ROUTER.API_TRANSFER_RECEIVE(transferId), data: {} }),
      response: baseResponse,
      loading,
    };
  },

  transferCancel: () => {
    const { request, baseResponse, loading } = useFetchData.Post<any>({
      projectId: ApiConfig.PROJECT_ID.ORDER_SERVICE,
    });
    return {
      fetch: (transferId: number) =>
        request({ endPoint: API_ORDER_ROUTER.API_TRANSFER_CANCEL(transferId), data: {} }),
      response: baseResponse,
      loading,
    };
  },
};

// Map trạng thái hiện tại → trạng thái tiếp theo (Simple workflow)
export const NEXT_STATUS_MAP: Record<number, { nextStatus: number; label: string }> = {
  [ORDER_STATUS.WAITING_ACCEPT]: { nextStatus: ORDER_STATUS.WAITING_PICK_UP, label: 'Xác nhận lấy hàng' },
  [ORDER_STATUS.WAITING_PICK_UP]: { nextStatus: ORDER_STATUS.WAITING_LAUNDRY, label: 'Hoàn thành lấy hàng' },
  [ORDER_STATUS.WAITING_LAUNDRY]: { nextStatus: ORDER_STATUS.IN_LAUNDRING, label: 'Bắt đầu giặt' },
  [ORDER_STATUS.IN_LAUNDRING]: { nextStatus: ORDER_STATUS.READY_DELIVERY, label: 'Hoàn thành giặt' },
  [ORDER_STATUS.READY_DELIVERY]: { nextStatus: ORDER_STATUS.IN_DELIVERY, label: 'Bắt đầu giao hàng' },
  [ORDER_STATUS.IN_DELIVERY]: { nextStatus: ORDER_STATUS.COMPLETE, label: 'Hoàn thành giao hàng' },
};

// Map trạng thái tiếp theo cho Extended workflow (static fallback khi không có workflow_steps).
// Quy trình rút gọn hiện tại (khớp FIXED_CHAIN ở backend workflow.service.ts):
//   WAITING_PICK_UP → INSPECTING → WASHING ("Đang sản xuất") → READY_DELIVERY → IN_DELIVERY → COMPLETE
// WASHING→READY_DELIVERY chỉ thực sự xảy ra khi ĐÓNG TÚI (gắn thiết bị BAG, xem OrderChangeStatusModal),
// KHÔNG qua nút chuyển trạng thái thường — entry này chỉ dùng để hiện icon/tooltip mở modal.
// WAITING_LAUNDRY/DRYING/IRONING/FOLDING: LEGACY FALLBACK — quy trình mới không tạo ra các trạng thái
// này nữa, giữ lại chỉ để đơn cũ còn dở dang có thể đi tiếp.
export const NEXT_EXTENDED_STATUS_MAP: Record<number, { nextStatus: number; label: string }> = {
  [ORDER_STATUS.WAITING_ACCEPT]: { nextStatus: ORDER_STATUS.WAITING_PICK_UP, label: 'Xác nhận lấy hàng' },
  [ORDER_STATUS.WAITING_PICK_UP]: { nextStatus: ORDER_STATUS.INSPECTING, label: 'Hoàn thành lấy hàng' },
  [ORDER_STATUS.INSPECTING]: { nextStatus: ORDER_STATUS.WASHING, label: 'Hoàn thành kiểm tra' },
  [ORDER_STATUS.WASHING]: { nextStatus: ORDER_STATUS.READY_DELIVERY, label: 'Đang sản xuất' },
  // LEGACY FALLBACK — đơn cũ còn dở dang ở chuỗi sấy/ủi/gấp trước khi rút gọn quy trình.
  [ORDER_STATUS.WAITING_LAUNDRY]: { nextStatus: ORDER_STATUS.WASHING, label: 'Bắt đầu giặt' },
  [ORDER_STATUS.DRYING]: { nextStatus: ORDER_STATUS.IRONING, label: 'Hoàn thành sấy' },
  [ORDER_STATUS.IRONING]: { nextStatus: ORDER_STATUS.FOLDING, label: 'Hoàn thành ủi' },
  [ORDER_STATUS.FOLDING]: { nextStatus: ORDER_STATUS.READY_DELIVERY, label: 'Hoàn thành gấp' },
  [ORDER_STATUS.READY_DELIVERY]: { nextStatus: ORDER_STATUS.IN_DELIVERY, label: 'Bắt đầu giao hàng' },
  [ORDER_STATUS.IN_DELIVERY]: { nextStatus: ORDER_STATUS.COMPLETE, label: 'Hoàn thành giao hàng' },
};

// Labels cho nút transition (mô tả hành động tại status hiện tại)
const TRANSITION_LABELS: Record<number, string> = {
  [ORDER_STATUS.WAITING_ACCEPT]: 'Xác nhận lấy hàng',
  [ORDER_STATUS.WAITING_PICK_UP]: 'Hoàn thành lấy hàng',
  [ORDER_STATUS.INSPECTING]: 'Hoàn thành kiểm tra',
  [ORDER_STATUS.WASHING]: 'Đang sản xuất',
  [ORDER_STATUS.WAITING_LAUNDRY]: 'Bắt đầu giặt',
  [ORDER_STATUS.DRYING]: 'Hoàn thành sấy',
  [ORDER_STATUS.IRONING]: 'Hoàn thành ủi',
  [ORDER_STATUS.FOLDING]: 'Hoàn thành gấp',
  [ORDER_STATUS.IN_LAUNDRING]: 'Hoàn thành giặt',
  [ORDER_STATUS.READY_DELIVERY]: 'Bắt đầu giao hàng',
  [ORDER_STATUS.IN_DELIVERY]: 'Hoàn thành giao hàng',
};

// Helper: lấy next status (chain cố định)
export const getNextStatusTransition = (order: OrderItem): { nextStatus: number; label: string } | null => {
  const currentStatus = Number(order.status);

  // Sub-order guard
  if (order.has_sub_orders === 1) return null;

  // Nhánh KIỂM ĐẾM (chain-of-custody) — ghi đè chuỗi tuyến tính, ĐỒNG BỘ với expectedNextStatus
  // của backend (order-laundry.service.ts): WAITING_ACCEPT→COUNTING→COUNTING_DONE→WAITING_DRIVER→WAITING_PICK_UP
  // và đầu giao IN_DELIVERY→DELIVERY_COUNTING→COMPLETE. Sai target → BE trả 400.
  const requiresCounting = Number(order.requires_counting) === 1;
  if (requiresCounting && currentStatus === ORDER_STATUS.WAITING_ACCEPT) {
    return { nextStatus: ORDER_STATUS.COUNTING, label: 'Nhận đơn để kiểm đếm' };
  }
  if (currentStatus === ORDER_STATUS.COUNTING) {
    return { nextStatus: ORDER_STATUS.COUNTING_DONE, label: 'Hoàn thành kiểm đếm nhận' };
  }
  if (currentStatus === ORDER_STATUS.COUNTING_DONE) {
    return { nextStatus: ORDER_STATUS.WAITING_DRIVER, label: 'Giao tài xế (lấy hàng)' };
  }
  if (currentStatus === ORDER_STATUS.WAITING_DRIVER) {
    return { nextStatus: ORDER_STATUS.WAITING_PICK_UP, label: 'Tài xế nhận hàng' };
  }
  if (requiresCounting && currentStatus === ORDER_STATUS.IN_DELIVERY) {
    return { nextStatus: ORDER_STATUS.DELIVERY_COUNTING, label: 'Kiểm đếm khi giao' };
  }
  if (currentStatus === ORDER_STATUS.DELIVERY_COUNTING) {
    return { nextStatus: ORDER_STATUS.COMPLETE, label: 'Hoàn thành giao hàng' };
  }

  return NEXT_EXTENDED_STATUS_MAP[currentStatus] || null;
};

export default OrderService;
export type { OrderItem as OrderListItem, OrderFilters as OrderListFilters, OrderApiResponse as OrderListApiResponse };
